module.exports = __webpack_public_path__ + "img/internal-onboarding-1.9fafc94d.jpeg";